import { state } from '@/store/module-data-state.js';
import { actions } from '@/store/module-data-actions.js';
import { mutations } from '@/store/module-data-mutations.js';

export default {
  state,
  actions,
  mutations
};
